import  { httpClient } from "./httpClient";

const END_POINT = "/postulant-exam";

export const postulantExam = {
  startOrGet({ eventExamId }) { 
    return httpClient.post(`${END_POINT}/start-or-get/${eventExamId}`);
  },
  finish({ id }) {
    return httpClient.post(`${END_POINT}/finish/${id}`, { });
  },
  get(id ) {
    return httpClient.get(`${END_POINT}/${id}`);
  }
};
